import {
	Card,
	ControlledInput,
	ControlledPhoneInput,
	HoverDetails,
} from "@dune/ui";
import React from "react";
import { useFormContext } from "react-hook-form";

export const MainDetails: React.FC = () => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	return (
		<div className="py-4">
			<div className="flex flex-row w-full">
				<div className="w-full flex items-center">
					<div className="flex items-center gap-2 text-text-main-blue font-semibold">
						Informations société
						<HoverDetails
							content={
								<div>
									Pour toute modification des informations société, <br />
									envoyer un email à l'adresse{" "}
									<span className="underline">contact@duneassurance.com</span>
								</div>
							}
						/>
					</div>
				</div>
				<div className="w-full flex items-center">
					<div className="text-text-main-blue font-semibold">Gérant</div>
				</div>
			</div>
			<div className="flex flex-row gap-4 pb-3">
				<div className="w-full flex flex-col gap-4">
					<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
						<div className="flex flex-row gap-4">
							<div className="flex flex-col items-start gap-3 w-full">
								<ControlledInput
									label="SIREN"
									control={control}
									name="siren"
									disabled
								/>
							</div>
						</div>
						<div className="flex flex-col items-start gap-3">
							<ControlledInput
								label="Dénomination"
								control={control}
								name="denomination"
								disabled
							/>
						</div>
						<div className="flex flex-col items-start gap-3">
							<div className="text-text-secondary-blue">
								Adresse du siège social
							</div>
							<ControlledInput
								control={control}
								name="headquartersAddress"
								disabled
							/>
						</div>
					</Card>
				</div>
				<div className="w-full flex flex-col gap-4">
					<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
						<div className="flex flex-row gap-4">
							<div className="flex flex-col items-start gap-3 w-full">
								<ControlledInput
									label="Nom"
									control={control}
									name="lastname"
									disabled
									error={errors.lastname?.message?.toString()}
								/>
							</div>
							<div className="flex flex-col items-start gap-3 w-full">
								<ControlledInput
									label="Prénom"
									control={control}
									name="firstname"
									disabled
									error={errors.firstname?.message?.toString()}
								/>
							</div>
						</div>
						<div className="flex flex-col items-start gap-3">
							<ControlledInput
								label="Email"
								control={control}
								name="email"
								disabled
								error={errors.email?.message?.toString()}
							/>
						</div>
						<div className="flex flex-col items-start gap-3">
							<div className="text-text-secondary-blue">Mobile</div>
							<ControlledPhoneInput
								control={control}
								name="phone"
								placeholder="Ex : +33 1 23 45 67 89"
								defaultCountry="FR"
								disabled
								error={errors.phone?.message?.toString()}
							/>
						</div>
					</Card>
				</div>
			</div>
		</div>
	);
};
